import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    tab: null,

    popup: {
        query: null,
        id_purchase: null,
        id_warehouse: null,
        id_supply_type: null,

        wasChanged: false,

        folder_params: {
            type: null,
            id_category: null,
            id_subcategory: null,
            id_product_group: [],
            id_node: null,
        },
    },
    open_schedule_popup: false,
    open_catalog_popup: false,
    supply_available_at: null,
}

export const stockSlice = createSlice({
    name: 'stockv2',
    initialState,
    reducers: {
        setStockPopupFolderParams: (state, action) => {
            const { id_purchase, ...params } = action.payload
            state.popup.folder_params = params
            state.popup.id_purchase = id_purchase
        },

        resetStockPopupFolderParams: (state, _) => {
            state.popup.folder_params = initialState.popup.folder_params
        },

        setStockPopupPurchase: (state, action) => {
            state.popup.id_purchase = action.payload
        },

        setStockPopupWarehouse: (state, action) => {
            state.popup.id_warehouse = action.payload
        },

        setStockPopupSupply: (state, action) => {
            state.popup.id_supply_type = action.payload
        },

        setSearchQueryAction: (state, action) => {
            state.popup.query = action.payload
        },

        resetSearchQueryAction: state => {
            state.popup.query = null
        },

        setWasChanged: state => {
            state.popup.wasChanged = true
        },

        toggleCatalogPopup: state => {
            // if (state.open_catalog_popup && state.popup.wasChanged) {
            //     state.tab = state.supply_available_at
            // }
            state.open_catalog_popup = !state.open_catalog_popup
            state.popup.wasChanged = false
        },

        toggleSchedulePopup: state => {
            state.open_schedule_popup = !state.open_schedule_popup
        },

        setSupplyAvailableDate: (state, action) => {
            state.supply_available_at = action.payload
        },

        setTab: (state, { payload }) => {
            state.tab = payload
        },
    },
})

export const selectStockSearchQuery = state => state.stockv2.popup.query

export const selectStockPopupPurchase = state => state.stockv2.popup.id_purchase

export const selectStockPopupSupplyType = state => state.stockv2.popup.id_supply_type

export const selectStockPopupWarehouse = state => state.stockv2.popup.id_warehouse

export const selectStockPopupFolderParams = state => state.stockv2.popup.folder_params

export const selectStockPopupFolderActiveNode = state => state.stockv2.popup.folder_params.id_node

export const selectStockSchedulePopup = state => state.stockv2.open_schedule_popup

export const selectStockCatalogPopup = state => state.stockv2.open_catalog_popup

export const selectSupplyAvailableAt = state => state.stockv2.supply_available_at

export const selectStockTab = state => state.stockv2.tab

export const selectWasChangedPopupStock = state => state.stockv2.popup.wasChanged

export const stockReducer = stockSlice.reducer
export const stockActions = stockSlice.actions
